import { Component, ContentChild, Input, TemplateRef, ViewEncapsulation,} from '@angular/core';
import { Gap } from '../v-layout/util';

/**
* @ignore - do not show in documentation
*/
@Component({
    selector:      "v-settings-group",
    styleUrls:     ['./v-settings-group.component.sass'],
    encapsulation: ViewEncapsulation.None,
    template:      `
    <v-column class="v-settings-group" [gap]="gap">
        <div *ngIf="header" class="header">
            <ng-container [ngTemplateOutlet]="headerTemplateRef" [ngTemplateOutletContext]="{$implicit: header}">
                <ng-container *ngIf="!headerTemplateRef">
                    <h1>{{header}}</h1>
                </ng-container>
            </ng-container>
        </div>
        <v-row class="entries">
            <ng-content></ng-content>
        </v-row>
    </v-column>`,
    standalone: false
})
export class VSettingsGroupComponent{
    @ContentChild('header', { static: false}) public headerTemplateRef: TemplateRef<unknown>;
    @Input() public header: unknown;
    @Input() public gap: Gap = "default";
}
